var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c00g1020"},[_c('main',{staticClass:"page-error mt-113 mt-100-sm"},[_c('div',{staticClass:"container"},[_c('MessageArea',{staticClass:"mb-24"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }